import axios from "../interceptors/axios";

export class FollowProjectService {
  store = async (data) => {
    try {
      const response = await axios.post("/api/follows/projects", data);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };
}

export class FollowAuthorService {
  store = async (data) => {
    try {
      const response = await axios.post("/api/follows/authors", data);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };
}
